module.exports = __webpack_public_path__ + "media/images/app/homepage/weddings/mother-of-the-bride-765c5a3c23ec94fece84260d3a102278.webp";